import { SetStateAction, useContext } from "react"
import ChatCard from "../ChatCard"
import { AuthContext, AuthContextType } from "@/features/app-layout/context";
import { AlarmClockCheck, Calendar, CopyPlus } from "lucide-react";
import { ChatMessageType } from "../../types";
import ThemeNavigationCard from "./ThemeNavigationCard";
import { useAtomValue } from "jotai";
import { themeAtom } from "@/features/app-layout/atoms/theme-atoms";
import { useGetThemes } from "../../api";
import { DateTime } from "luxon";
import ThemeCarousel from "./ThemeCarousel";
import ThemeCampaignCard from "./ThemeCamaignCard";
import { useNavigate } from "react-router-dom";

type Props = {
  setStep: (id: ChatMessageType) => void,
  setStatus: React.Dispatch<SetStateAction<number | undefined>>,
  onThemeSelect: (id: number, nav: string) => void,
  onReasoning: (name: string, why: string) => void,
}

const ThemeNavigation = ({ setStep, setStatus }: Props) => {

  const { name } = useContext<AuthContextType>(AuthContext)

  const navigate = useNavigate()

  const appTheme = useAtomValue(themeAtom)

  const { themes } = useGetThemes(1, DateTime.now()
    .setZone("America/New_York")
    .toFormat("yyyy-MM-dd"), 1)

  return (
    <>
      <ChatCard user="assistant">
        <div className="w-full flex flex-col gap-2 lg:gap-4">
          <div className="font-header text-lg text-gray-700 font-semibold">Hey {name} 🤘</div>
          <p className="text-xs md:text-sm text-gray-500 font-poppins leading-5 tracking-wider">Ready to spark your brand today? Choose what you want to do — explore fresh campaign ideas, check your calendar, prompt a post, revisit past campaigns, or keep your brand story always on point.</p>
          <div className="w-full min-h-40">
            <ThemeCarousel themes={themes ? themes.data : []} onNavigate={() => {
              setStatus(1)
              setStep("first")
            }} images={themes ? themes.images : []} />
          </div>
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-3">
            <ThemeNavigationCard name="Your Social Media Calendar" description="Check out your agenda" emoji="📅" onNavigate={() => {
              setStep("calendar")
            }} icon={Calendar} />
            <ThemeNavigationCard name="Make Your Own Post" description={`Create customized theme ${!appTheme.isClient ? "( currently disabled )" : ""}`} emoji="🧩" onNavigate={() => {
              if (appTheme.isClient) {
                navigate('/home/create')
              }
            }} icon={CopyPlus} />
            {/* <ThemeNavigationCard name="Past Date Campaigns" description="Themes you missed out on" emoji="🔕" onNavigate={() => {
              setStatus(undefined)
              setStep("first")
            }} icon={History} /> */}
            <ThemeCampaignCard className="lg:col-span-2"
                name="Brand Campaigns" description="Your brand affiliated posts" emoji="🚀" onNavigate={() => {
                  setStatus(5)
                  setStep("campaign")
              }} icon={AlarmClockCheck}  />
          </div>
        </div>
      </ChatCard>
    </>
  )
}

export default ThemeNavigation
